import { cn } from "@/lib/cn";
import Icon from "@components/ui/icon";
import { useViewContext } from "@editor-providers";
import type { ReactNode } from "react";
import { useActive } from "../providers";
import { STYLED_TITLE_ATTRIBUTES, TitleStyled } from "../styles/Titles.styled";
import type { TabTitleType, TabsPayload } from "../types";

export const Title = ({
  title,
  settings,
  className,
  attributes,
  emitActive,
  forceActive,
  editorSlots,
}: {
  title: TabTitleType;
  settings: TabsPayload;
  attributes: Record<string, unknown>;
  className?: string;
  emitActive?: (id: string) => void;
  forceActive?: boolean;
  editorSlots?: {
    editableContent: ReactNode;
    titleOutline: ReactNode;
    placeholder?: boolean;
  };
}) => {
  const { view } = useViewContext();
  const { setActive, active } = useActive();
  if (!title) return null;

  return (
    <TitleStyled
      {...STYLED_TITLE_ATTRIBUTES({ settings })}
      {...attributes}
      onClick={() => {
        if (view === "pdf") return;
        setActive(title.id);
        if (emitActive) emitActive(title.id);
      }}
      key={title.id}
      className={cn(
        "tw-relative tw-flex tw-h-full tw-cursor-pointer tw-items-center tw-justify-center tw-border-solid tw-p-3 tw-text-center tw-font-paragraph tw-font-bold tw-transition tw-duration-200 max-md:tw-px-4 max-md:tw-py-2",
        {
          "--active":
            forceActive || active === title.id || !!editorSlots?.placeholder,
          'tw-bg-[transparent] tw-transition-colors tw-duration-200 after:tw-absolute after:tw-bg-[transparent] after:tw-content-[""]':
            settings.tabsDesign === "design-2",
          "tw-rounded-none": settings.tabsDesign === "design-1",
          [className || ""]: !!className,
        },
      )}
    >
      {settings.isShowTabsIcons && (
        <Icon
          icon={title.icon}
          className="tw-mr-2 tw-flex tw-shrink-0 tw-items-center tw-justify-center"
        />
      )}
      {editorSlots?.editableContent ? editorSlots.editableContent : title.name}
      {editorSlots?.titleOutline}
    </TitleStyled>
  );
};
